
export const subjectValidator = (subject, allowedSchools) => {
    if (typeof subject.name !== 'string' || subject.name === '') {
        return {valid: false, msg: 'User name must not be empty'}
    }
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (typeof subject.email !== 'string' || !emailRegex.test(subject.email)) {
        return {valid: false, msg: 'User email must be a valid email'}
    }
    if (typeof subject.school !== 'string' || !allowedSchools.includes(subject.school)) {
        return {valid: false, msg: 'User school must be a valid school'}
    }
    return {valid: true}
}